export default __webpack_public_path__ + "static/media/jio_icon.3a94dbe2.png";